import 'react-toastify/dist/ReactToastify.css';

import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import RouteTracker from './Components/RouteTracker';

const App = () => {
  return (
    <Fragment>
      <RouteTracker />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Outlet />
    </Fragment>
  );
};

export default App;